import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../config/service";
import CryptoJS from "crypto-js";
import { HMAC_SECRET_KEY } from "../../config/api.config";

export const b2bApiService = createApi({
  reducerPath: "b2bApiService",
  baseQuery: axiosBaseQuery(),
  endpoints: (builder) => ({
    createb2bUsers: builder.mutation({
      query: (data) => {
        // const token = JSON.parse(localStorage.getItem("token"));
        return {
          url: "/jaaga/api/user/btob/request",
          data: data,
          method: "POST",
        //   headers: { "x-auth-token": token },
        };
      },
      invalidatesTags: ["b2b"],
    }),
  }),
});

export const { useCreateb2bUsersMutation } = b2bApiService;
